var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListBulletedEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332",
    transform: "translate(-628 -368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    transform: "translate(628 368)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2331",
    "data-name": "Group 2331"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    x2: 13,
    transform: "translate(636 374)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    x2: 13,
    transform: "translate(636 380)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    x2: 13,
    transform: "translate(636 386)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(630 376)",
    fill: "#0d0d0d",
    fontSize: 4,
    fontFamily: "Verdana-Bold, Verdana",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(630 381)",
    fill: "#0d0d0d",
    fontSize: 4,
    fontFamily: "Verdana-Bold, Verdana",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(630 387)",
    fill: "#0d0d0d",
    fontSize: 4,
    fontFamily: "Verdana-Bold, Verdana",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBulletedEditorIcon);
export default __webpack_public_path__ + "static/media/list-bulleted-editor-icon.2fc354be03b88a6aa3f83c8364e60606.svg";
export { ForwardRef as ReactComponent };